<template>
  <div id="applyUnbind">
    <el-form :model="applyUnbindForm" :rules="rules" ref="applyUnbindForm" label-width="120px" class="applyUnbindForm">
      <el-form-item label="解绑店铺" prop="mallCode">
        <el-select v-model="applyUnbindForm.mallCode" placeholder="请选择" @change="changeMall">
          <el-option
            v-for="item in mallList"
            :key="item.mallCode"
            :label="item.mallName"
            :value="item.mallCode">
            <span class="y-f y-f-a">
              <img :src="require(`@/assets/images/ecommercepng/icon_dianpu_${item.platformCode}.png`)" class="iconstyle" alt="">
              {{ item.mallName }}
            </span>
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="原收款人姓名" prop="alipayRealName">
        <el-input v-model="applyUnbindForm.alipayRealName" placeholder="请输入" disabled></el-input>
      </el-form-item>
      <el-form-item label="合作网点" prop="branchCode">
        <el-select
          v-model="applyUnbindForm.branchCode"
          filterable
          remote
          placeholder="请输入网点名称或编号"
          :remote-method="remoteMethod"
          :loading="loading"
          @focus="clearOptionList">
          <el-option
            v-for="(item, index) in optionList"
            :key="index"
            :label="item.orgName"
            :value="item.orgCode">
          </el-option>
        </el-select>
        <el-tooltip effect="light" placement="right-start" class="tooltip-style">
          <div slot="content">
            <span style="color:#666666">合作网点请选择您授权店铺合作网点，将由合作网点审核解绑</span>
          </div>
          <span class="helpInfo setting-btn y-c-p y-ml-5"><img src="@/assets/images/icon_tips@2x.png"/></span>
        </el-tooltip>
      </el-form-item>
       <el-form-item label="联系电话" prop="relationTelephone">
        <el-input v-model="applyUnbindForm.relationTelephone" placeholder="请输入"></el-input>
      </el-form-item>
      <el-form-item label="申请说明" prop="applyReason">
        <el-input type="textarea" v-model="applyUnbindForm.applyReason" :autosize="{ minRows: 3}" placeholder="请输入" maxlength="300"></el-input>
      </el-form-item>
        <!-- action="/webApi/customerFastDfs/uploadFile" -->
      <el-form-item label="图片">
        <el-upload
          ref="upload"
          class="uploadImg"
          action="/steward/web/workOrder/uploadWorkOrderImg"
          list-type="picture-card"
          :limit="5"
          :class="{hide:showUpload}"
          accept=".jpg,.jpeg,.png,.gif"
          :on-exceed="handleExceed"
          :headers="headers"
          :before-upload="beforeAvatarUpload"
          :on-success="uploadSuccess"
          :on-preview="handlePictureCardPreview"
          :on-remove="handleRemove">
          <i class="el-icon-plus">上传照片</i>
        </el-upload>
          <template>
            <div id="tar_box" contenteditable="" v-if="!showUpload" @input="focusTarBox"></div>
            <div class="el-form-item__error uploadImg_error" v-if="imgError">图片不能为空</div>
            <div  class="el-upload__tip">支持jpg、jpeg、gif、png格式的图片，最多上传5张，单张图片大小不超过5M，支持复制粘贴上传</div>
          </template>
      </el-form-item>
      <el-form-item label-width="0" class="form-btn">
        <el-button class="y-w-100" @click="close">取消</el-button>
        <el-button class="y-w-100" type="primary" @click="applyUnbind('applyUnbindForm')">确定</el-button>
      </el-form-item>
    </el-form>
    <el-dialog :visible.sync="dialogVisible" append-to-body close="img-dialog">
      <img width="100%" :src="dialogImageUrl" alt="">
    </el-dialog>
  </div>
  
</template>
<script> 
import {queryOrgInfoApi} from '../../../api/baseInfo/printSetting/electronicFaceAccount';
import { applyUnbindAliPayAccountByQuicksettlementApi } from '../../../api/quickIndemnity/quicksettlement';
import { getStore } from '@/utils/localStorage';
export default {
  name: 'applyUnbind',
   props: {
    applyUnbindInfo:{
      type: Object,
      default:{}
    }
  },
  data() {
    
    return {
      applyUnbindForm: {
        mallCode: '',
        alipayRealName:'',
        branchCode: '',
        relationTelephone: '',
        applyReason: '',
      },
      mallList:[],
      optionList:[],
      rules: {
        mallCode: [
          { required: true, message: '请选择解绑店铺', trigger: 'change' },
        ],
        alipayRealName: [
          { required: true, message: '请输入收款人姓名', trigger: 'blur' }
        ],
        branchCode: [
          { required: true, message: '请选择合作网点', trigger: 'change' }
        ],
        relationTelephone: [
          { required: true, message: '请输入联系电话', trigger: 'blur' }
        ],
        applyReason: [
          { required: true, message: '请输入申诉说明', trigger: 'blur' }
        ]
      },
      loading: false,
      headers: {
        'source': 'YTO-STEWARD',
        'jwt-token': getStore('stewoard-token')
      },
      showUpload: false,
      imgError: false,
      dialogImageList:[],
      dialogImageUrl: '',
      dialogVisible: false
    };
  },
  mounted(){
    this.$nextTick(() => {
      this.mallList = this.applyUnbindInfo.data;
      let info = this.applyUnbindInfo.data[0]
      this.applyUnbindForm.mallCode = info.mallCode;
      this.applyUnbindForm.alipayRealName = info.alipayRealName;
      this.applyUnbindForm.relationTelephone = info.relationTelephone;
      this.applyUnbindForm = {...this.applyUnbindForm}
    })
    let _this = this;
    document.addEventListener('paste', function (event) {
      if(event.target.id=='tar_box'){
        let isChrome = false;
        if (event.clipboardData || event.originalEvent) {
          //not for ie11  某些chrome版本使用的是event.originalEvent
          let clipboardData = (event.clipboardData || event.originalEvent.clipboardData);
          if (clipboardData.items) {
            // for chrome
            let items = clipboardData.items,
                len = items.length,
                blob = null;
            isChrome = true;
            //items.length比较有意思，初步判断是根据mime类型来的，即有几种mime类型，长度就是几（待验证）
            //如果粘贴纯文本，那么len=1，如果粘贴网页图片，len=2, items[0].type = 'text/plain', items[1].type = 'image/*'
            //如果使用截图工具粘贴图片，len=1, items[0].type = 'image/png'
            //如果粘贴纯文本+HTML，len=2, items[0].type = 'text/plain', items[1].type = 'text/html'
            //阻止默认行为即不让剪贴板内容在div中显示出来
            event.preventDefault();
            //在items里找粘贴的image,据上面分析,需要循环
            for (let i = 0; i < len; i++) {
              if (items[i].type.indexOf("image") !== -1) {
                blob = items[i].getAsFile();
              }
            }
            if (blob !== null) {
              let reader = new FileReader();
              reader.onload = function (event) {
                // event.target.result 即为图片的Base64编码字符串
                let base64_str = event.target.result
                //可以在这里写上传逻辑 直接将base64编码的字符串上传（可以尝试传入blob对象，看看后台程序能否解析）
                _this.uploadImgFromPaste(base64_str, 'paste', isChrome);
              }
              reader.readAsDataURL(blob);
            }
          } else {
            //for firefox
            setTimeout(function () {
              //设置setTimeout的原因是为了保证图片先插入到div里，然后去获取值
              let imgList = document.querySelectorAll('#tar_box img'),
                len = imgList.length,
                src_str = '',
                i;
              for (i = 0; i < len; i++) {
                if (imgList[i].className !== 'my_img') {
                  //如果是截图那么src_str就是base64 如果是复制的其他网页图片那么src_str就是此图片在别人服务器的地址
                  src_str = imgList[i].src;
                }
              }
              _this.uploadImgFromPaste(src_str, 'paste', isChrome);
            }, 1);
          }
        } else {
          //for ie11
          setTimeout(function () {
            let imgList = document.querySelectorAll('#tar_box img'),
              len = imgList.length,
              src_str = '',
              i;
            for (i = 0; i < len; i++) {
              if (imgList[i].className !== 'my_img') {
                src_str = imgList[i].src;
              }
            }
            //调用上传方法
            _this.uploadImgFromPaste(src_str, 'paste', isChrome);
          }, 1);
        }
      }
    })
  },
  methods: {
    changeMall(value){
    this.applyUnbindForm.mallCode = value;
    let curMallList = this.mallList.filter(o => {return o.mallCode == value; });
    this.mallList = this.applyUnbindInfo.data;
      let info = curMallList[0]
      this.applyUnbindForm.mallName = info.mallName;
      this.applyUnbindForm.alipayRealName = info.alipayRealName;
      this.applyUnbindForm.relationTelephone = info.relationTelephone;
      this.applyUnbindForm = {...this.applyUnbindForm}
    },
    focusTarBox(){
      document.getElementById('tar_box').innerHTML = '';
    },
     /**调用element的上传方法 需要把base64转换成file上传**/
    uploadImgFromPaste(file, type, isChrome) {
      if(this.showUpload){
        return false;
      }
      if (this.dialogImageList.length && this.dialogImageList.length >= 5) {
        this.$message.warning(`最多可以选择 5 个文件`);
        return false;
      }
      let a = this.dataURLtoBlob(file);
      let b = this.blobToFile(a);
      const upload = this.$refs.upload;
      upload.handleStart(b);
      this.$nextTick(()=>{
        upload.submit();
      })
    },
    /**
     * 将base64转换为blob
     */
    dataURLtoBlob (dataurl) {
      var arr = dataurl.split(','),
      mime = arr[0].match(/:(.*?);/)[1],
      bstr = atob(arr[1]),
      n = bstr.length,
      u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
    return new Blob([u8arr], { type: mime });
    },
     /**
     * 将blob转换为file
     */
    blobToFile  (theBlob, fileName = 'ocr1.jpeg') {
        theBlob.lastModifiedDate = new Date();
        theBlob.name = fileName;
        return theBlob;
    },
    // 上传前
    beforeAvatarUpload(file) {
      if (!/^(image\/(jpeg|png|gif))$/.test(file.type)) {
        this.$alert('上传图片暂时只支持JPEG、JPG、PNG、GIF格式', '提示', {
          confirmButtonText: '关闭',
          type: 'error'
        });
        return false;
      }
      if (file.size > 5 * 1024 * 1024) {
        this.$alert('图片大小不超过5M', '提示', {
          confirmButtonText: '关闭',
          type: 'error'
        });
        return false;
      }
      return true;
    },
     // 上传成功
    uploadSuccess(res, file, fileList) {
      if (fileList.length >= 5) {
        // 上传图片大于等于4张时隐藏上传按钮
        this.showUpload = true;
      }
      this.dialogImageList.push({uid: file.uid, imgFullPath: res.data.imgFullPath, imgPath: res.data.imgPath});
    },
     handleRemove(file, fileList) {
      // console.log(file, fileList);
      if (fileList.length < 5) {
        // 上传图片小于5张时展示上传按钮
        this.showUpload = false;
      }
      this.dialogImageList.forEach((r, index) => {
        if (r.uid === file.uid) {
          this.dialogImageList.splice(index, 1);
        }
      });
      this.dialogImageList = [...this.dialogImageList];
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    handleExceed(files, fileList) {
      this.$message.warning(`最多可以选择 5 个文件`);
    },
    clearOptionList() {
      this.optionList = [];
    },
    remoteMethod(query) {
      console.log('query',query)
      if (query == '') {
        this.applyUnbindForm.branchInfo = '';
        this.optionList = [];
        return false;
      }
      this.loading = true;
      setTimeout(() => {
        this.loading = false;
        this.queryOrgInfo(query);
      }, 200);
    },
     // 网点信息
    async queryOrgInfo(str) {
      await queryOrgInfoApi(str || '').then(res => {
        if (res.status === 0) {
          this.optionList = res.data || [];
        } else {
          this.optionList = [];
        }
      }).catch(() => {
        this.optionList = [];
      });
    },
    close(){
      this.$nextTick(() => {
        this.dialogImageList = [];
        this.showUpload = false;
        this.imgError = false;
        this.$refs.applyUnbindForm.resetFields();
        this.$emit('close');
      })
    },
    applyUnbind(formName){
      this.$refs[formName].validate((valid) => {
        if (valid) {
          console.log(this[formName],this.dialogImageList)
          let curMallList = this.mallList.filter(o => {return o.mallCode == this.applyUnbindForm.mallCode; });
          let orgList = this.optionList.filter(o => {return o.orgCode == this.applyUnbindForm.branchCode; });
          let params = {
            mallCode: this.applyUnbindForm.mallCode,
            mallName: (curMallList&&curMallList.length)?curMallList[0].mallName:'',
            platformCode: (curMallList&&curMallList.length)?curMallList[0].platformCode:'',
            alipayRealName: this.applyUnbindForm.alipayRealName,
            applyReason: this.applyUnbindForm.applyReason,
            branchCode: this.applyUnbindForm.branchCode,
            branchName: (orgList&&orgList.length)?orgList[0].orgName:'',
            relationTelephone: this.applyUnbindForm.relationTelephone,
            applyUnbindVerifyCode: this.applyUnbindInfo.authCode,
          }
          if(this.dialogImageList && this.dialogImageList.length){
            let imgList = this.dialogImageList.filter(t => t.imgPath).map(r=> r.imgPath);
            console.log(imgList)
            params.applyPicture = imgList.join();
          }
          applyUnbindAliPayAccountByQuicksettlementApi(params).then(res => {
            if (res.status == 200 && res.data) {
              this.$message.success(res.data);
              this.$nextTick(() => {
                // this.$emit('next','applyUnbind',res.data,1);
                this.$emit('close');
              })
            } else {
              this.$message.error(res.error);
            }
          });
         
        } else {
          console.log('error submit!!');
          return false;
        }
      });
      
    }
  }
}
</script>
<style lang="scss" scoped>
.iconstyle {
  width: 12px;
  height: 12px;
} 
</style>
<style lang="scss" rel="stylesheet/scss">
@import "../../../styles/variables";
#applyUnbind{
  .applyUnbindForm{
    .el-form-item--small.el-form-item{
      margin: 0 auto 18px auto;
    }
    .el-input{
      width: 250px;
    }
    .el-textarea{
      width: 440px;
    }
    .form-btn{
      display: block;
      margin-left: 0;
      margin-top: 40px!important;
      text-align: center;
    }
  }
  .setting-btn{
    img{
      width: 14px;
      vertical-align: text-bottom;
      margin-right: 4px;
    }
  }
  .helpInfo{
    font-size: 12px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #333333;
    line-height: 14px;
  }
  .hide .el-upload--picture-card {
    display: none;
  }
  .uploadImg{
    display: contents;
    height: 60px;
    .el-upload{
      width: 60px;
      height: 60px;
      line-height: 62px;
    }
    .el-upload-list{
      width: 60px;
      height: 60px;
    }
    .el-upload-list--picture-card .el-upload-list__item{
      width: 60px;
      height: 60px;
      margin-bottom: 0;
    }
    .el-upload-list--picture-card .el-upload-list__item-status-label {
      right: -18px;
      top: -16px;
      width: 40px;
      height: 35px;
    }
    .el-upload-list--picture-card .el-upload-list__item-status-label i {
      margin-top: 20px;
    }
    .el-upload-list__item-actions i {
      font-size: 16px;
    }
    .el-upload-list--picture-card .el-upload-list__item-actions span+span{
      margin-left: 10px;
    }
    .el-icon-plus{
      font-size: 12px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      height: 100%;
      &::before{
        font-size: 20px;
        margin-bottom: 5px;
      }
    }
  }
  .img-dialog{
    /deep/.el-dialog__header {
        height: 20px;
    }
  }
  #tar_box{
    width: 60px;
    height: 60px;
    display: inline-block;
    background-color: #fbfdff;
    border: 1px dashed #c0ccda;
    border-radius: 6px;
    margin-left: 8px;
    box-sizing: border-box;
    &::before{
      content: '\590d\5236\7c98\8d34';//复制粘贴
      width: 60px;
      display: block;
      text-align: center;
      font-size: 12px;
      line-height: 60px;
      color: #8c939d;
    }
    &:focus{
      outline:1px dashed $blue-style;
    }
  }
}
</style>
